/**
 * @desc: 差错处理
 * @created: 2020/09/07
 * @author: huli
 * @version: v1.0
 */

import * as Models from '@/api/T6/errorHandling'

export default {
  namespaced: true,
  actions: {
    getListData(ctx, payload) {
      return Models.getListData(payload).then(res => {
        return (res && res.status === 200 && res.data) || [{}, {}]
      })
    },

    getDetails(ctx, payload) {
      return Models.getDetails(payload).then(res => {
        // console.log('差错处理详情', res)
        return res
      })
    },


    getSelectCoordinatr(ctx, payload) {
      return Models.getSelectCoordinatr(payload).then(res => {
        return (res && res.status === 200 && res.data) || []
      })
    },

    getBlend(ctx, payload) {
      return Models.getBlend(payload).then(res => {
        return (res && res.status === 200 && res.data) || []
      })
    },

  }
}
